import { Button } from 'foundations-components/transitional/components/Button';
import { PortalMessage, useBreakpoint } from 'portals-platform-lib';
import { usePortalData } from '../data/usePortalData';
import { useNavigationContext } from '../hooks/useNavigationContext';
import { usageTracker } from '../utils/usageTracker';
import { jsx as _jsx } from "react/jsx-runtime";
export function CreateTicketButton() {
  const {
    data
  } = usePortalData();
  const {
    formMenuText,
    formGuid
  } = (data === null || data === void 0 ? void 0 : data.settings) || {};
  const {
    toNewTicket
  } = useNavigationContext();
  const isMobile = useBreakpoint() === 'mobile';
  if (!formGuid) return null;
  return /*#__PURE__*/_jsx(Button, {
    "data-test-id": "create-ticket-button",
    use: "primary",
    size: isMobile ? 'small' : undefined,
    onClick: () => {
      usageTracker.track('Customer Portal App', 'Tickets Manipulated', {
        action: 'create-ticket-clicked',
        screen: 'ticket-listings'
      });
      toNewTicket();
    },
    children: /*#__PURE__*/_jsx(PortalMessage, {
      messageKey: "SUPPORT_SPACE_FORM_MENU_TEXT",
      fallback: formMenuText
    })
  });
}